// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3YU0i","col":"styles_col__1wnqB","fulfillmentStatus":"styles_fulfillmentStatus__2Oki8","emailCol":"styles_emailCol__3beNH"};